import styled from "styled-components";

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;

    svg {
        margin-right: 8px;
    }
`;